import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import {ViewCell} from '../../ng2-smart-table/components/cell/cell-view-mode/view-cell';

@Component({
  selector: 'app-table-user-status',
  templateUrl: './table-user-status.component.html',
  styleUrls: ['./table-user-status.component.scss']
})
export class TableUserStatusComponent implements ViewCell, OnInit {
  
  @Input() value: string | number;
  @Input() rowData: any; 
  statusText: string;
  statusClass: string;
  @Output() resendclicked: EventEmitter<any> = new EventEmitter();
  constructor() { }

  ngOnInit() {
    if (+this.rowData.status === 0) {
      this.statusText = 'Unverified';
      this.statusClass = 'not-verified';
    } else if (+this.rowData.status === 1) {
      this.statusText = 'Verified';
      this.statusClass = 'active';
    }
  }

  onResendClick():void {
    this.resendclicked.emit(this.rowData);
  }

}
